import React from 'react';
import { storesContext, useStores } from '../hooks/useStores';

const { Provider, Consumer } = storesContext;

const StoreProvider = ({ children }: { children?: React.ReactNode }) => {
  const {
    appStateStore,
    vesselScenarioStore,
    portStore,
    yardSafeStore,
    configStore,
    themeStore,
    portHealthStore,
  } = useStores();

  return (
    <Provider
      value={{
        appStateStore,
        vesselScenarioStore,
        portStore,
        yardSafeStore,
        configStore,
        themeStore,
        portHealthStore,
      }}
    >
      {children}
    </Provider>
  );
};

export { Consumer as StoreConsumer, StoreProvider };

